import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { ArrowForward, ArrowForwardIos } from '@mui/icons-material';


export default function OutlinedCard({ title, content, onPress }: { title: string, content: string, onPress?: () => void }) {
    return (
        <Box onClick={onPress}>
            <Card sx={{
                width: 200,
                height: 180,
                margin: 2,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#f0f0f0',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                },
                '&:active': {
                    backgroundColor: '#e0e0e0',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                },
                '&:focus': {
                    outline: 'none',
                },
                '&:focus-visible': {
                    outline: '2px solid #1976d2',
                },
                '&:focus-within': {
                    outline: '2px solid #1976d2',
                },
            }} variant="outlined">
                <React.Fragment>
                    <CardContent>
                        <Typography variant="h5" component="div">
                            {title}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            {content}
                            <br />
                        </Typography>
                    </CardContent>
                </React.Fragment>
            </Card>
        </Box>
    );
}